export const ADMIN_RESULTTAGS_REQUEST = 'ADMIN_RESULTTAGS_REQUEST';
export const ADMIN_RESULTTAGS_SUCCESS = 'ADMIN_RESULTTAGS_SUCCESS';
export const ADMIN_RESULTTAGS_ERROR = 'ADMIN_RESULTTAGS_ERROR';

export const ADMIN_RESULTTAG_REQUEST = 'ADMIN_RESULTTAG_REQUEST';
export const ADMIN_RESULTTAG_SUCCESS = 'ADMIN_RESULTTAG_SUCCESS';
export const ADMIN_RESULTTAG_ERROR = 'ADMIN_RESULTTAG_ERROR';

export const ADMIN_ADD_RESULTTAG_REQUEST = 'ADMIN_ADD_RESULTTAG_REQUEST';
export const ADMIN_ADD_RESULTTAG_SUCCESS = 'ADMIN_ADD_RESULTTAG_SUCCESS';
export const ADMIN_ADD_RESULTTAG_ERROR = 'ADMIN_ADD_RESULTTAG_ERROR';

export const ADMIN_UPDATE_RESULTTAG_REQUEST = 'ADMIN_UPDATE_RESULTTAG_REQUEST';
export const ADMIN_UPDATE_RESULTTAG_SUCCESS = 'ADMIN_UPDATE_RESULTTAG_SUCCESS';
export const ADMIN_UPDATE_RESULTTAG_ERROR = 'ADMIN_UPDATE_RESULTTAG_ERROR';

export const ADMIN_DELETE_RESULTTAG_REQUEST = 'ADMIN_DELETE_RESULTTAG_REQUEST';
export const ADMIN_DELETE_RESULTTAG_SUCCESS = 'ADMIN_DELETE_RESULTTAG_SUCCESS';
export const ADMIN_DELETE_RESULTTAG_ERROR = 'ADMIN_DELETE_RESULTTAG_ERROR';

export const ADMIN_RESULTSURVEY_REQUEST = 'ADMIN_RESULTSURVEY_REQUEST';
export const ADMIN_RESULTSURVEY_SUCCESS = 'ADMIN_RESULTSURVEY_SUCCESS';
export const ADMIN_RESULTSURVEY_ERROR = 'ADMIN_RESULTSURVEY_ERROR';

export const GET_REPORT_SURVEY_REQUEST = 'GET_REPORT_SURVEY_REQUEST';
export const GET_REPORT_SURVEY_SUCCESS = 'GET_REPORT_SURVEY_SUCCESS';
export const GET_REPORT_SURVEY_ERROR = 'GET_REPORT_SURVEY_ERROR';
